import { CheckCircle } from "lucide-react";
import { useSavedIndicator } from "@/hooks/use-saved-indicator";

// Global "Saved" pill (Task #2874). Renders in the app header and animates in
// for ~2s after any successful mutation, then fades back out. Always occupies
// its slot in the layout (no remount) so the fade transition can run; only the
// opacity/translate change between states.
export function SavedIndicator() {
  const visible = useSavedIndicator();
  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-medium text-green-600 dark:text-green-400 transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-1 pointer-events-none"
      }`}
      aria-hidden={!visible}
      data-testid="saved-indicator"
    >
      <CheckCircle className="h-4 w-4" />
      Saved
    </span>
  );
}
